import api from '@/api/login'
import { forceAddWatermark, initWatermark } from '@/common/watermark'

import store from '@/store/store'

const user = {
  state: {
    token: store.getToken(),
    user: store.getUser()
  },
  getters: {
    token: state => state.token,
    user: state => state.user,
    name: state => (state.user ? state.user.name : null)
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
      if (token) {
        store.setToken(token)
      } else {
        store.removeToken()
      }
    },
    SET_USER: (state, user) => {
      state.user = user
      if (user) {
        store.setUser(user)
      } else {
        store.removeUser()
      }
    }
  },
  actions: {
    // Login ({ commit, state }, data) {
    //   return new Promise((resolve, reject) => {
    //     api.login(data).then((data) => {
    //       store.setToken(data.token)
    //       commit('SET_TOKEN', data.token)
    //       resolve()
    //     }).catch(error => {
    //       reject(error)
    //     })
    //   })
    // },
    // 第三方验证登录
    ThirdLogin ({ commit, state }, accessToken) {
      return new Promise((resolve, reject) => {
        store.setToken(accessToken)
        commit('SET_TOKEN', accessToken)
        resolve()
      })
    },
    // 获取用户信息
    GetInfo ({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.getInfo().then(data => {
          console.log('用户信息API返回的数据:', data)
          console.log('用户名字段:', data.name)
          commit('SET_USER', data)
          initWatermark()
          setTimeout(() => {
            forceAddWatermark()
          }, 500)
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut ({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.logout().then(() => {})
        store.removeToken()
        store.removeUser()
        resolve()
      })
    },
    // 前端 登出
    FedLogOut ({ commit }) {
      return new Promise(resolve => {
        store.removeToken()
        store.removeUser()
        resolve()
      })
    }
  }
}

export default user
